import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import logo from '../assets/logo.png';
import '../css/Sidebar.css';

import * as FiIcons from 'react-icons/fi';
import * as PiIcons from "react-icons/pi";
import * as MdIcons from "react-icons/md";

const FiMenu = FiIcons.FiMenu as unknown as React.FC;
const FiHome = FiIcons.FiHome as unknown as React.FC;
const FiUsers = FiIcons.FiUsers as unknown as React.FC;
const FiClock = FiIcons.FiClock as unknown as React.FC;
const FiList = FiIcons.FiList as unknown as React.FC;
const FiLogOut = FiIcons.FiLogOut as unknown as React.FC;
const FiPackage = FiIcons.FiPackage as unknown as React.FC;
const PiMoney = PiIcons.PiMoneyWavyBold as unknown as React.FC;
const MdActivity = MdIcons.MdSportsEsports as unknown as React.FC;

const Sidebar: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

 const { logout } = useContext(AuthContext);

  const menuItems = [
    { label: 'Dashboard', icon: <FiHome />, path: '/dashboard' },
    { label: 'Customers', icon: <FiUsers />, path: '/customers' },
    { label: 'Queries', icon: <FiList />, path: '/queries' },
    { label: 'Follow-ups', icon: <FiClock />, path: '/followups' },
    { label: 'Bookings', icon: <PiMoney />, path: '/bookings' },
    { label: 'Activities', icon: <MdActivity />, path: '/activities' },
    { label: 'Packages', icon: <FiPackage />, path: '/packages' },
  ];

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        {!collapsed && <img src={logo} alt="Logo" className="logo" />}
        <button className="menu-btn" onClick={() => setCollapsed(!collapsed)}>
          <FiMenu />
        </button>
      </div>

      <nav className="sidebar-nav">
        <ul>
          {menuItems.map((item) => (
            <li key={item.label}>
              <Link to={item.path} className="sidebar-link">
                {item.icon}
                {!collapsed && <span style={{ marginLeft: '12px' }}>{item.label}</span>}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      <div className="logout-section">
        <button className="logout-btn" onClick={logout}>
          <FiLogOut />
          {!collapsed && <span style={{ marginLeft: '12px' }}>Logout</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
